<div class="start-page" *ngIf="page">
  <vw-page [page]="page" [showDealerInformation]="true">
    <vw-car-and-dealer
      [caption]="
        page.media | media: mediaCategoryTypeNames.Caption : mediaTypes.Text
      "
      [ingress]="
        page.media | media: mediaCategoryTypeNames.Ingress : mediaTypes.Text
      "
      [hero]="
        page.media | media: mediaCategoryTypeNames.Hero : mediaTypes.Image
      "
    ></vw-car-and-dealer>

    <div *ngFor="let lb of linkBlocks">
      <vw-link-block [linkBlock]="lb"></vw-link-block>
    </div>

    <vw-popular-products></vw-popular-products>
  </vw-page>
</div>
